import Label from 'components/Label';


const FAQSideText = ({ title, tag }) => {
    return (
        <div className='faq-sidetext'>
            <Label text={tag} />
            <h2>{title}</h2>
        </div>
    );
}

export default FAQSideText;